import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('cds-table')
export class TableElement extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 100%;
    }
  `;

  @property({ type: String, reflect: true })
  role = 'table';

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-table': TableElement;
  }
}
